export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/4c9d57c9ff1d197a3d06bc2def8662e1.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-8 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-3">
            <h2 className="text-7xl font-bold text-white leading-tight mb-12">
              Crafting Premium<br />
              iOS Applications<br />
              for Modern Users
            </h2>
            <p className="text-2xl text-gray-200 leading-relaxed max-w-2xl">
              Expert team developing cutting-edge VPN and Cleaner solutions for enhanced mobile security and performance.
            </p>
          </div>
          
          <div className="lg:col-span-2 flex justify-center">
            <div className="relative w-full max-w-md h-96">
              <div className="absolute top-0 right-0 w-48 h-48 bg-gradient-to-br from-purple-500/30 to-blue-500/30 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-blue-500/30 to-purple-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-56 h-56 bg-gradient-to-br from-purple-600/40 to-blue-600/40 rounded-3xl blur-2xl animate-pulse" style={{ animationDelay: '0.5s' }}></div>
            </div>
          </div>
        </div>
        
        <div className="mt-32 text-center">
          <h3 className="text-8xl font-bold text-white tracking-tight">
            INNOVATION IN YOUR POCKET
          </h3>
        </div>
      </div>
    </section>
  );
}